import { type VoidFunctionComponent } from 'react';

import { FilterPanel } from '../../../../../../../generic';
import type { ProjectsFilter } from '../../../../../../../../../shared/projectsV2';
import type { SelectOption } from '../../../../../../../../types';
import type { TeamSelectOption } from '../../../../../../../shared/teams/hooks/useTeamsSelectOptions';
import type { SetProjectsFilter } from '../../../types';

import ProjectLabelsFilter from './ProjectLabelsFilter/ProjectLabelsFilter';
import ProjectLastRevisionFilter from './ProjectLastRevisionFilter/ProjectLastRevisionFilter';
import { ProjectSourceFilter } from './ProjectSourceFilter/ProjectSourceFilter';
import ProjectTeamsFilter from './ProjectTeamsFilter/ProjectTeamsFilter';
import ProjectVisibilityFilter from './ProjectVisibilityFilter/ProjectVisibilityFilter';

import styles from './ProjectsFilters.module.less';

type Props = {
  setFilters: SetProjectsFilter;
  filters: ProjectsFilter;
  labelsFilters: {
    isLoading: boolean;
    labelOptions: SelectOption[];
    selectedLabelOptions: SelectOption[];
    handleLabelsChange: (selected: SelectOption[]) => void;
  };
  teamsFilters: {
    isLoading: boolean;
    teamOptions: TeamSelectOption[];
    selectedTeamOptions: TeamSelectOption[];
    onTeamsSelected: (selected: TeamSelectOption[]) => void;
  };
};

const FiltersTitle: VoidFunctionComponent = () => {
  return (
    <div className={styles.filterTitle}>Filters</div>
  );
};

const ProjectsFilters: VoidFunctionComponent<Props> = ({ filters, setFilters, labelsFilters, teamsFilters }) => {
  return (
    <FilterPanel title={<FiltersTitle />}>
      <div className={styles.filterGroup}>
        <ProjectSourceFilter setFilters={setFilters} filters={filters} />
        <ProjectVisibilityFilter setFilters={setFilters} isPublic={filters.isPublic} />
        <ProjectTeamsFilter
          isLoading={teamsFilters.isLoading}
          teamOptions={teamsFilters.teamOptions}
          selectedTeamOptions={teamsFilters.selectedTeamOptions}
          onTeamsSelected={teamsFilters.onTeamsSelected}
        />
        <ProjectLabelsFilter
          isLoading={labelsFilters.isLoading}
          labelOptions={labelsFilters.labelOptions}
          selectedLabelOptions={labelsFilters.selectedLabelOptions}
          handleLabelsChange={labelsFilters.handleLabelsChange}
        />
        <ProjectLastRevisionFilter setFilters={setFilters} lastRevisionWithin={filters.lastRevisionWithin} />
      </div>
    </FilterPanel>
  );
};

export default ProjectsFilters;
